<template>
    <div class="udi-section p-2">
        <div>
            <label class="mb-0">
                GMDN PT Name
                <span v-tooltip="{ title: gmdnPtNameTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.Name }}
            </p>
        </div>
        <div>
            <label class="mb-0">
                Device Description
                <span v-tooltip="{ title: deviceTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.Description }}
            </p>
        </div>
        <div>
            <label class="mb-0">
                Brand Name
                <span v-tooltip="{ title: brandNameTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.BrandName }}
            </p>
        </div>
        <div>
            <label class="mb-0">
                Version or Model
                <span v-tooltip="{ title: versionTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.VersionModelNumber }}
            </p>
        </div>
        <div>
            <label class="mb-0"> Company Name: </label>
            <p class="mb-0">
                {{ implantableDevice.CompanyName }}
            </p>
        </div>
        <div>
            <label class="mb-0">
                What MRI safety information does the labeling contain?
                <span v-tooltip="{ title: mriTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.SafetyInformation }}
            </p>
        </div>
        <div>
            <label class="mb-0">
                Device required to be labeled as containing natural rubber latex or dry natural rubber (21 CFR 801.437)
                <span v-tooltip="{ title: deviceLabelTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.HasNaturalRubber }}
            </p>
        </div>
        <div>
            <label class="mb-0"> Lot/Batch Number: </label>
            <p class="mb-0">
                {{ implantableDevice.LotBatchNumber }}
            </p>
        </div>
        <div>
            <label class="mb-0"> Serial Number: </label>
            <p class="mb-0">
                {{ implantableDevice.SerialNumber }}
            </p>
        </div>
        <div>
            <label class="mb-0"> Expiration Date: </label>
            <p class="mb-0">
                {{ formatDate(implantableDevice.ExpirationDate) }}
            </p>
        </div>
        <div>
            <label class="mb-0"> Manufacturing Date: </label>
            <p class="mb-0">
                {{ formatDate(implantableDevice.ManufacturingDate) }}
            </p>
        </div>
        <div>
            <label class="mb-0"> Issuing Agency: </label>
            <p class="mb-0">
                {{ implantableDevice.IssuingAgency }}
            </p>
        </div>
        <div>
            <label class="mb-0">
                Human cell, tissue or cellular or tissue-based product (HCT/P)
                <span v-tooltip="{ title: hctTooltip }"> <i class="fas fa-info-circle text-info"></i> </span>:
            </label>
            <p class="mb-0">
                {{ implantableDevice.IsHumanOrIssueProduct ? "YES" : "NO" }}
            </p>
        </div>
    </div>
</template>

<style src="./ImplantableValidationSection.scss" />
<script lang="ts" src="./ImplantableValidationSection.ts" />
